<!-- 生成库存盘点计划 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                              <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                              <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                           </div>
                           <!-- 明细信息 -->
                           <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="detailsList" border size="mini" :height="mxHeight">
                              <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in mxForm.jurconfigform" :key="formOneKey"
                                               :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow==1" show-overflow-tooltip>
                                 <template slot-scope="scope">
                                    <!-- 生产日期 -->
                                    <span v-if="formOneValue.fieldType == 'date'">
                                       <span v-if="scope.row[formOneValue.entityField]">
                                          {{$common.getLocalTime(scope.row[formOneValue.entityField])}}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
                                    </span>
                                    <span v-else>
                                       {{scope.row[formOneValue.entityField]}}
                                    </span>
                                 </template>
                              </el-table-column>
                           </el-table>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                    @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
         <initDataUpload :url="url" :errorUrl="'stockDifference/exportChangeFail'" :listShow="true" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
         </initDataUpload>
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "stockDifferenceAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            detailsList: [],
            selectedDataIndex: 0,
            showTabs: "",
            formDataList: [],
            tabForm: [
                {
                    isShowForm: 0,
                    jciName: "查看信息",
                },
            ],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            exWidth: "",
            parentSearchData: {},
            mxHeight: 0,
            mxForm: [],
            footForm: [],
            importShow: false,
            importType: "",
            url: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 触发组件的提交
        fileSuccess(val) {},
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false;
            if (val.list.length > 0) {
                // 处理新数据并设置默认值
                const processedItems = val.list.map((item) => ({
                    ...item,
                }));
                // 过滤重复项
                const existingBgmIds = new Set(
                    this.detailsList.map((item) => item.bgmId)
                );
                const uniqueNewItems = processedItems.filter(
                    (item) => !existingBgmIds.has(item.bgmId)
                );

                // 添加到列表
                this.detailsList.push(...uniqueNewItems);
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/stockDifference/downChangeDetailExcel`;
        },
        importDetails() {
            this.importShow = true;
            this.url = `stockDifference/exportChangeDetail`;
            this.importType = "stockDifferenceexportChangeDetail";
        },
        handleChange(value, name) {
            console.log(value, name);
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) {
                this.$parent.$parent.toDetail(orderId);
            } else {
                this.$parent.$parent.$parent.toDetail(orderId);
            }
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            console.log(val);
            this.DialogVisible = false;
            console.log(this.seType);
            if (val != "" || val != undefined) {
                if (this.seType == "stId") {
                    this.sendDataInfo.stName = val.stName;
                    this.sendDataInfo.stId = val.stId;
                    this.parentSearchData.movmOutstid =
                        this.sendDataInfo.movmOutstid;
                } else if (this.seType == "coId") {
                    this.sendDataInfo.coName = val.coName;
                    this.sendDataInfo.coId = val.coId;
                } else if (this.seType == "bgmName") {
                    for (let fkey in this.sendDataInfo.movedetailAdds[
                        this.seIndex
                    ]) {
                        for (let vkey in val) {
                            if (fkey == vkey) {
                                this.sendDataInfo.movedetailAdds[this.seIndex][
                                    fkey
                                ] = val[vkey];
                            }
                        }
                    }
                    this.sendDataInfo.movedetailAdds[
                        this.seIndex
                    ].movdOutbgsid = val.bgsId;
                }
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type) {
            console.log(type, "----7");
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            if (type == "stId") {
                this.parentSearchData["stName"] = this.sendDataInfo["stName"];
            }
            if (type == "coId") {
                this.parentSearchData["coName"] = this.sendDataInfo["coName"];
            }
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },

        initActionBox(sendDataInfo) {
            this.$emit("drawerCancel", 0);
            this.$refs.sendDataInfo.resetFields();
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = "查看信息";
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.detailsList=this.sendDataInfo.detailList
                console.log(this.detailsList,"测试");
                
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                }, 16.7);
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(
                        JSON.stringify(item.jurconfigform)
                    );
                }
            });
        },
        // 新增或者编辑
        async sendDataAction() {
            let sendData = JSON.parse(JSON.stringify(this.detailsList));
            var responseData = await this.$http.stockDifferenceMasteradd(sendData);
            if (responseData.status == 200) {
                this.$emit("drawerCancel", 1);
                this.$message.success("操作成功");
            } else {
                this.$message.error(responseData.message);
            }
        },
        deleteDetails(index) {
            if (this.sendDataInfo.movedetailAdds.length > 0) {
                this.sendDataInfo.movedetailAdds.splice(
                    this.selectedDataIndex,
                    1
                );
                this.selectedDataIndex = 0;
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
        // this.getAllStorageRoom();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>